/** Hardcoded fallback when neither event nor organization coords are available. */
export const FALLBACK_MAP_CENTER = {
	lat: 41.673614755657454,
	lng: 2.2847488443187474,
}

/**
 * Parse lat/lng into a usable map center.
 * Treats null/NaN and Null Island (0,0) as unset — common defaults in this codebase.
 */
export function parseMapCoords(
	lat: unknown,
	lng: unknown
): { lat: number; lng: number } | null {
	const parsedLat = Number(lat)
	const parsedLng = Number(lng)
	if (!Number.isFinite(parsedLat) || !Number.isFinite(parsedLng)) {
		return null
	}
	if (parsedLat === 0 && parsedLng === 0) {
		return null
	}
	return { lat: parsedLat, lng: parsedLng }
}

export function isFallbackMapCenter(center: { lat: number; lng: number } | null | undefined): boolean {
	if (!center) return true
	return center.lat === FALLBACK_MAP_CENTER.lat && center.lng === FALLBACK_MAP_CENTER.lng
}

export function getOrganizationInitialCenter(
	org: {
		initial_position_latitude?: unknown
		initial_position_longitude?: unknown
	} | null | undefined
): { lat: number; lng: number } | null {
	if (!org) return null
	return parseMapCoords(
		org.initial_position_latitude,
		org.initial_position_longitude
	)
}

/**
 * Resolve map center with precedence:
 * 1. Preferred event/activity coords (when valid)
 * 2. Organization "Initial Position for Events"
 * 3. Hardcoded fallback
 */
export function resolveMapCenter(
	preferred?: { lat?: unknown; lng?: unknown } | null,
	org?: {
		initial_position_latitude?: unknown
		initial_position_longitude?: unknown
	} | null
): { lat: number; lng: number } {
	const fromPreferred =
		preferred != null ? parseMapCoords(preferred.lat, preferred.lng) : null
	if (fromPreferred) return fromPreferred
	return getOrganizationInitialCenter(org) ?? { ...FALLBACK_MAP_CENTER }
}
